<template>
	<div class="column is-3 is-flex is-flex-direction-column">
		<button class="add-card" @click="$emit('click')">
			<span class="icon is-large">
				<i class="fas fa-plus"></i>
			</span>
			<span class="poppins-medium">Add new</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'AddCard',
	emits: ['click'],
};
</script>

<style scoped>
.add-card {
	width: 100%;
	min-height: 120px;
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 10px;
	border: 2px dashed #70cb7c;
	border-radius: 20px;
	background-color: transparent;
	color: #70cb7c;
	cursor: pointer;
}
.add-card:hover {
	background-color: #1e1f25;
}
.add-card .icon {
	font-size: 1.8rem;
}
</style>
